var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTree = function SvgTree(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 8 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "CurrentColor",
    fillRule: "evenodd",
    d: "M4 7.292c.247 0 .448.204.448.455v5.198c0 .251-.2.455-.448.455a.451.451 0 0 1-.448-.455V7.747c0-.251.2-.455.448-.455Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "CurrentColor",
    fillRule: "evenodd",
    d: "M6.304 8.397V3.849c0-1.292-1.031-2.34-2.304-2.34-1.272 0-2.304 1.048-2.304 2.34v4.548c0 1.292 1.032 2.339 2.304 2.339 1.273 0 2.304-1.047 2.304-2.34ZM4 .6C2.233.6.8 2.054.8 3.849v4.548c0 1.794 1.433 3.249 3.2 3.249 1.767 0 3.2-1.455 3.2-3.25V3.85C7.2 2.054 5.767.6 4 .6Z",
    clipRule: "evenodd"
  })));
};
export default SvgTree;